export default "__VITE_ASSET__8d3a55a5__"